import React, { useEffect } from 'react'
import './index.scss';
import { API_URL } from "../../../../../constants/ApplicationUrl";
import { underscoreToSpace } from '../../../../../dependencies/utils/helper';
function InnovationGrading({ data, setAdminScores, adminScores }) {

  useEffect(() => {
    setAdminScores({
      intellectualProperty: data?.ScoreCard?.score?.adminScore?.intellectualProperty,
      achievementsAwards: data?.ScoreCard?.score?.adminScore?.achievementsAwards,
      stageOfProductService: data?.ScoreCard?.score?.adminScore?.stageOfProductService,
      employmentOfResearchPersonnel: data?.ScoreCard?.score?.adminScore?.employmentOfResearchPersonnel,
    });
  }, [data]);

  const handleScoreChange = (field, value) => {
    setAdminScores((prev) => ({
      ...prev,
      [field]: Number(value),
    }));
  };

  return (
    <>
      <h3 className='board-title'>Broad Parameters</h3>
      <div className="entity-detail-inner table-card">
        <table>
          <thead>
            <tr>
              <th className="score-marks">
                <table>
                  <tr>
                    <th>
                      Innovation Grading <span>(Max Marks : 100)</span>
                    </th>
                    <th>SIH User Marks</th>
                    <th>Admin Response</th>
                    <th>Admin Marks</th>
                  </tr>
                </table>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="tbody">
                <table>
                  <tr>
                    <td>
                      <div className="row-ca">
                        <div className="content">
                          <h6> Intellectual Property Creation in Company Name (Copyrights/ Patents / Industrial Design) </h6> <span>:</span>
                        </div>
                        <div className="view-list">
                          <p>
                            {underscoreToSpace(data?.Parameters?.broadParameter?.intellectualProperty)}
                            {data?.Parameters?.broadParameter?.intellectualPropertyDocument ? (<a href={`${API_URL()}${data?.Parameters?.broadParameter?.intellectualPropertyDocument?.publicUrl}`}
                              target="_blank"
                              rel="noopener noreferrer">View Document</a>): (null)}
                            

                          </p>

                        </div>
                      </div>
                    </td>
                    <td>{data?.ScoreCard?.score?.sihScore?.intellectualProperty}</td>
                    <td>
                      <select
                        className="form-select"
                        value={adminScores.intellectualProperty}
                        onChange={(e) => handleScoreChange("intellectualProperty", e.target.value)}
                      >
                        {data?.ScoreCard?.score ? (null):(<option value=''>--Select One--</option>)}
                        <option value="0">NOT FILED</option>
                        <option value="10">FILED</option>
                        <option value="20">PUBLISHED</option>
                        <option value="25">GRANTED</option>

                      </select>
                    </td>
                    <td>{adminScores.intellectualProperty}</td>
                  </tr>
                  <tr>
                    <td>
                      <div className="row-ca">
                        <div className="content">
                          <h6> Achievements and Awards</h6> <span>:</span>

                        </div>
                        <div className="view-list">
                          <p>
                            {underscoreToSpace(data?.Parameters?.broadParameter?.achievementsAwards)}
                            {data?.Parameters?.broadParameter?.achievementsAwardsDocument ? (<a href={`${API_URL()}${data?.Parameters?.broadParameter?.achievementsAwardsDocument?.publicUrl}`}
                              target="_blank"
                              rel="noopener noreferrer">View Document</a>): (null)}
                            

                          </p>

                        </div>
                      </div>
                    </td>
                    <td>{data?.ScoreCard?.score?.sihScore?.achievementsAwards}</td>
                    <td>   <select
                      className="form-select"
                      value={adminScores.achievementsAwards}
                      onChange={(e) => handleScoreChange("achievementsAwards", e.target.value)}
                    >
                      {data?.ScoreCard?.score ? (null):(<option value=''>--Select One--</option>)}
                      <option value="0">NO AWARD</option>
                      <option value="10">DISTRICT AWARD</option>
                      <option value="20">STATE AWARD</option>
                      <option value="25">NATIONAL AWARD</option>
                    </select></td>
                    <td>{adminScores?.achievementsAwards}</td>
                  </tr>
                  <tr>
                    <td>
                      <div className="row-ca">
                        <div className="content">
                          <h6>Stage of Product/Service</h6> <span>:</span>

                        </div>
                        <div className="view-list">
                          <p>
                            {underscoreToSpace(data?.Parameters?.broadParameter?.stageOfProductService)}
                            {data?.Parameters?.broadParameter?.stageOfProductServiceDocument ? (<a href={`${API_URL()}${data?.Parameters?.broadParameter?.stageOfProductServiceDocument?.publicUrl}`}
                              target="_blank"
                              rel="noopener noreferrer">View Document</a>): (null)}
                            

                          </p>

                        </div>
                      </div>
                    </td>
                    <td>{data?.ScoreCard?.score?.sihScore?.stageOfProductService}</td>
                    <td>  <select
                      className="form-select"
                      value={adminScores.stageOfProductService}
                      onChange={(e) => handleScoreChange("stageOfProductService", e.target.value)}
                    >
                      {data?.ScoreCard?.score ? (null):(<option value=''>--Select One--</option>)}
                      <option value="0">IDEATION</option>
                      <option value="10">VALIDATION</option>
                      <option value="20">EARLY TRACTION</option>
                      <option value="25">SCALING</option>



                    </select></td>
                    <td>{adminScores.stageOfProductService}</td>
                  </tr>
                  <tr>
                    <td>
                      <div className="row-ca">
                        <div className="content">
                          <h6>Employment of Research Personnel (M.Tech/PHD Holders)</h6> <span>:</span>

                        </div>
                        <div className="view-list">
                          <p>
                            {underscoreToSpace(data?.Parameters?.broadParameter?.employmentOfResearchPersonnel)}
                            {data?.Parameters?.broadParameter?.employmentOfResearchPersonnelDocument ? (<a href={`${API_URL()}${data?.Parameters?.broadParameter?.employmentOfResearchPersonnelDocument?.publicUrl}`}
                              target="_blank"
                              rel="noopener noreferrer">View Document</a>): (null)}
                            

                          </p>

                        </div>
                      </div>
                    </td>
                    <td>{data?.ScoreCard?.score?.sihScore?.employmentOfResearchPersonnel}</td>
                    <td> <select
                      className="form-select"
                      value={adminScores.employmentOfResearchPersonnel}
                      onChange={(e) => handleScoreChange("employmentOfResearchPersonnel", e.target.value)}
                    >
                      {data?.ScoreCard?.score ? (null):(<option value=''>--Select One--</option>)}
                      <option value="0">EMP PHD 0</option>
                      <option value="10">EMP PHD 1-10</option>
                      <option value="20">EMP PHD 10-25</option>
                      <option value="25">EMP PHD ABOVE 25</option>
                    </select></td>
                    <td>{adminScores?.employmentOfResearchPersonnel}</td>
                  </tr>

                </table>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td className="tfoot">
                <table>

                  <tr>
                    <td>
                      <h6>Sectional Marks Obtained <span>SIH User Marks </span></h6>
                    </td>
                    <td>{data?.ScoreCard?.score?.sihScore?.totalGroup1Score
                    }</td>
                    <td>Admin Marks</td>
                    <td>{adminScores?.employmentOfResearchPersonnel + adminScores.stageOfProductService + adminScores?.achievementsAwards + adminScores.intellectualProperty}</td>
                    {/* <td>{data?.ScoreCard?.score?.adminScore?.totalGroup1Score}</td> */}

                  </tr>
                </table>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </>
  )
}

export default InnovationGrading
